<template>
  <div>
    <logined v-if="userInfo" />
    <un-login v-else />
  </div>
</template>

<script>
import unLogin from "./unlogin.vue";
import logined from "./logined.vue";
export default {
  computed:{
    userInfo(){
      return localStorage.getItem("userInfo");
    }
  },
  components: {
    unLogin,
    logined,
  }
};
</script>